"use strict";
/*eslint radix: ["error", "as-needed"]*/
const angular = require("angular");

import Siret from "siret";
import _ from "underscore";

export class IdentificationController {
  constructor(
    arrow,
    $uibModal,
    $log,
    LanguageService,
    IdentificationAPI,
    ProductAPI,
    $location,
    screenSize,
    Modal,
    gettextCatalog,
    $http
  ) {
    "ngInject";
    this.arrow = arrow;
    var that = this;

    this.isSiret = false;
    this.isVatNumber = false;
    this.Siret = Siret;
    this.$http = $http;

    this.Modal = Modal;
    this.gettextCatalog = gettextCatalog;

    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });

    this.title = {
      fr: {
        10000: "M.",
        10001: "Mme",
      },
      en: {
        10000: "Mr.",
        10001: "Mrs",
      },
    };
    this.IdentificationAPI = IdentificationAPI;
    this.ProductAPI = ProductAPI;
    this.contacts = [];
    this.societies = [];

    this.ls = LanguageService;
    this.s = $location.search();
    if (this.s.demand && parseInt(this.s.demand) && that.s.date) {
      if (this.s.project && parseInt(this.s.project)) {
        this.refreshClients().then(() => {
          ProductAPI.getRestricted({
            id: parseInt(that.s.demand),
          })
            .$promise.then((demand) => {
              /*if(!demand) {
                  arrow.goto(2);
                }*/
              if (!demand || (demand && demand.project.id != that.s.project)) {
                $location.path("/permission").search({});
                return null;
              }
              that.demand = JSON.parse(JSON.stringify(demand));

              that.disabledInput = false;
              if (
                that.demand.status &&
                parseInt(that.demand.status) % 10 !== 1
              ) {
                that.disabledInput = true;
                that.arrow.disableConfirmation = true;
                if (parseInt(that.demand.status) % 10 === 3) {
                  that.blockedInput = true;
                }
              }

              //Si la date de modification ne correspond pas à la date dans l'URL
              let dateAmended = new Date(that.demand.dateAmended).getTime();
              if (!that.disabledInput && that.s.date != dateAmended) {
                that.arrow.goto(2);
                return;
              } //*/

              if (
                parseInt(that.demand.status) == 50 ||
                parseInt(that.demand.status) == 60 ||
                parseInt(that.demand.status) == 70 ||
                parseInt(that.demand.status) == 74 ||
                parseInt(that.demand.status) == 80 ||
                parseInt(that.demand.status) == 90
              ) {
                that.arrow.goto(4, this.s.project, that.demand.id);
              }

              that.loadClients();
              return null;
            })
            .catch(() => {
              //arrow.goto(2);
              $location.path("/permission");
              return null;
            });
        });
      } else {
        arrow.goto(1);
      }
    } else {
      arrow.goto(2);
    }

    this.animationsEnabled = true;
    this.open = function (form, action, type) {
      /*var parentSelector= 'body';
      var parentElem = parentSelector ?
        angular.element($document[0].querySelector(parentSelector)) : undefined;*/
      let data = null;
      if (action == "update") {
        let tCap = type.replace(/\b\w/g, function (l) {
          return l.toUpperCase();
        });
        data = that[form + tCap];
      }
      if (type == "address") {
        data = data || {};
        if (that[`${form}Society`]) {
          data.clientId = that[`${form}Society`].id;
        } else if (
          that[`${form}Contact`] &&
          that[`${form}Contact`].privateIndividual
        ) {
          data.isPriviteAndNoSociety = true;
          data.contactId = that[`${form}Contact`].id;
        }
      }
      var modalInstance = $uibModal.open({
        windowClass: "modal-warning",
        animation: that.animationsEnabled,
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        component: "client",
        size: "lg",
        resolve: {
          parameters() {
            return {
              action,
              type,
              data,
              userId: that.clients.userId,
            };
          },
        },
      });
      //Traiter le resultat venant du popup
      modalInstance.result.then(
        function (result) {
          //Mettre à jour la liste de tous les coordonnèes
          that.refreshClients().then(() => {
            //Mettre à jour le formulaire en fonction des données qu'on reçoit du popup
            // for (let _t in result) {
            //   let tCap = _t.replace(/\b\w/g, function (l) {
            //     return l.toUpperCase();
            //   });
            //   console.log(_t);
            //   let list = [];
            //   if (_t == "contact") {
            //     list = that.contacts;
            //   }
            //   if (_t == "society") {
            //     list = that.societies;
            //   }
            //   if (_t == "address") {
            //     that[`${form}Society`] =
            //       _.findWhere(that.societies, {
            //         id: that[`${form}Society`].id,
            //       }) || null;
            //     list = that[`${form}Society`].address || [];
            //   }
            //   that[form + tCap] =
            //     _.findWhere(list, {
            //       id: result[_t],
            //     }) || null;
            // }

            // par ordre contact society address
            if (result) {
              if (result.contact) {
                that[`${form}Contact`] = _.findWhere(that.contacts, {
                  id: result.contact,
                });
              }
              if (result.society) {
                that[`${form}Society`] = _.findWhere(that.societies, {
                  id: result.society,
                });
              }
              if (result.address) {
                that[`${form}Society`] =
                  _.findWhere(that.societies, {
                    id: that[`${form}Society`].id,
                  }) || null;
                let list = that[`${form}Society`].address || [];
                that[`${form}Address`] = _.findWhere(list, {
                  id: result.address,
                });
              }
            }
            that.loadLocalClient();
          });
        },
        function () {
          //$log.info(`Modal dismissed at: ${new Date()}`);
        }
      );
    };
  }

  contactChanged(form) {
    let that = this;
    if (that[`${form}Contact`] && that[`${form}Contact`].privateIndividual) {
      let societyId = that[`${form}Contact`].societyId;
      if (societyId) {
        that[`${form}Society`] =
          _.findWhere(that.societies, { id: societyId }) || null;

        if (that[`${form}Society`]) {
          let society = that[`${form}Society`];
          that[`${form}Address`] =
            society.address && society.address.length > 0
              ? society.address[0]
              : null;
        }
      } else {
        that[`${form}Society`] = null;
        that[`${form}Adress`] = null;
      }
    }
  }

  societyChanged(addressName, society, societyName) {
    if (society) {
      this[addressName] =
        society.address && society.address.length > 0
          ? society.address[0]
          : null;
      this.checkSiret(society.siret, societyName);
      this.checkVatNumber(society.vatNumber, societyName);
    }
  }

  checkSiret(siret, society) {
    let that = this;
    this[society].isValidSiret = false;
    // console.log(siret);
    if (siret) {
      siret = siret.trim();
      siret = siret.replace(/\s/g, "");
      siret = siret.replace(/[^0-9]/g, "");
      if (this.Siret.isSIRET(siret)) {
        // this.$http.get('https://entreprise.data.gouv.fr/api/sirene/v1/siret/' + siret)
        //   .then((resp) => {
        //     if (resp.status == 200) {
        //       // console.log(resp.data.etablissement);
        //       if (resp.data && resp.data.etablissement) {
        //         that[society].isValidSiret = true;
        //       }
        //     }
        //   })
        //   .catch(err => {});
        return this.IdentificationAPI.checkSiret({
          siret: siret,
        })
          .$promise.then((resp) => {
            resp = JSON.parse(JSON.stringify(resp));
            if (resp && resp.forceSiret) {
              that[society].isValidSiret = true;
            }
            if (resp && resp.etablissement) {
              that[society].isValidSiret = true;
            }
          })
          .catch((err) => {});
      }
    }
  }

  checkVatNumber(vatNumber, society) {
    let that = this;
    this[society].isValidVatNumber = false;
    if (vatNumber) {
      vatNumber = vatNumber.trim().toUpperCase();
      vatNumber = vatNumber.replace(/\s/g, "");
      vatNumber = vatNumber.replace(/[^a-zA-Z0-9]/g, "");
      if (vatNumber.length >= 10) {
        return this.IdentificationAPI.checkVatNumber({
          countryCode: vatNumber.substring(0, 2),
          vatNumber: vatNumber.substring(2),
        })
          .$promise.then((resp) => {
            resp = JSON.parse(JSON.stringify(resp));
            if (resp && resp.valid) {
              that[society].isValidVatNumber = true;
            }
          })
          .catch((err) => {});
      }
    }
  }

  refreshClients() {
    var that = this;
    return this.IdentificationAPI.getClients()
      .$promise.then((result) => {
        that.clients = JSON.parse(JSON.stringify(result));
        if (result) {
          that.owner = that.clients.owner;
          that.contacts = that.clients.contacts;
          that.societies = that.clients.societies;
        }
        return;
      })
      .catch(() => {
        console.log("Error on get clients");
        return;
      }); // @@@ Handle popup
  }

  loadClients() {
    var that = this;
    that.mainIsInvoice = false;
    that.mainIsFinal = true;
    that.finalIsInvoice = false;

    let dContact = that.owner
      ? _.findWhere(that.contacts, {
          id: that.owner.id,
        })
      : null;
    let dSociety = null;
    if (that.clients.latestSocietyId) {
      dSociety =
        _.findWhere(that.societies, {
          id: that.clients.latestSocietyId,
        }) || null;
    }
    if (!dSociety) {
      //Si on n'arrive pas à le trouver
      dSociety =
        that.owner && that.owner.society
          ? _.findWhere(that.societies, {
              id: that.owner.society.id,
            })
          : null;
    }

    let dAddress = dSociety && dSociety.address ? dSociety.address[0] : null;

    that.mainIsFinal = that.demand.mainIsFinal;
    that.mainIsInvoice = that.demand.mainIsInvoice;
    that.finalIsInvoice = that.demand.finalIsInvoice;

    that.mainContact = that.demand.contactIdMain
      ? _.findWhere(that.contacts, {
          id: that.demand.contactIdMain,
        })
      : dContact;
    that.finalContact = that.demand.contactIdFinal
      ? _.findWhere(that.contacts, {
          id: that.demand.contactIdFinal,
        })
      : null;
    that.invoiceContact = that.demand.contactIdInvoice
      ? _.findWhere(that.contacts, {
          id: that.demand.contactIdInvoice,
        })
      : null;

    that.mainSociety = that.demand.societyIdMain
      ? _.findWhere(that.societies, {
          id: that.demand.societyIdMain,
        })
      : dSociety;
    that.finalSociety = that.demand.societyIdFinal
      ? _.findWhere(that.societies, {
          id: that.demand.societyIdFinal,
        })
      : null;
    that.invoiceSociety = that.demand.societyIdInvoice
      ? _.findWhere(that.societies, {
          id: that.demand.societyIdInvoice,
        })
      : null;

    that.mainAddress =
      that.demand.addressIdMain && that.mainSociety && that.mainSociety.address
        ? _.findWhere(that.mainSociety.address, {
            id: that.demand.addressIdMain,
          })
        : dAddress;
    that.finalAddress =
      that.demand.addressIdFinal &&
      that.finalSociety &&
      that.finalSociety.address
        ? _.findWhere(that.finalSociety.address, {
            id: that.demand.addressIdFinal,
          })
        : null;
    that.invoiceAddress =
      that.demand.addressIdInvoice &&
      that.invoiceSociety &&
      that.invoiceSociety.address
        ? _.findWhere(that.invoiceSociety.address, {
            id: that.demand.addressIdInvoice,
          })
        : null;

    if (that.mainIsFinal) {
      that.finalContact = that.mainContact;
      that.finalSociety = that.mainSociety;
      that.finalAddress = that.mainAddress;
    }
    if (that.mainIsInvoice) {
      that.invoiceContact = that.mainContact;
      that.invoiceSociety = that.mainSociety;
      that.invoiceAddress = that.mainAddress;
    }
    if (!that.mainIsInvoice && that.finalIsInvoice) {
      that.invoiceContact = that.finalContact;
      that.invoiceSociety = that.finalSociety;
      that.invoiceAddress = that.finalAddress;
    }
    that.checkAllSiretAndVatNumberValid();
  }

  enableChange() {
    var that = this;
    if (this.demand.status) {
      let status = parseInt(this.demand.status);
      let demand = JSON.parse(JSON.stringify(this.demand));
      demand.status = status - (status % 10) + 1;
      this.ProductAPI.changeStatus(demand).$promise.then(() => {
        that.demand.status = demand.status;
        that.disabledInput = false;
      });
    }
  }

  prev(form) {
    this.submitted = true;
    if (this.demand.id) {
      if (this.disabledInput) {
        this.arrow.goto(2, this.s.project, this.s.demand);
      } else {
        let toPage = 2;
        this.save(true, toPage);
      } //*/
    }
  }

  isSiretAndVatNumberValid() {
    return !(
      this.invoiceSociety.isFrenchRegisteredCompany == null ||
      this.invoiceSociety.hasVatNumber == null ||
      (this.mainSociety &&
        this.mainSociety.isFrenchRegisteredCompany &&
        !this.mainSociety.isValidSiret) ||
      (this.invoiceSociety &&
        this.invoiceSociety.isFrenchRegisteredCompany &&
        !this.invoiceSociety.isValidSiret) ||
      (this.finalSociety &&
        this.finalSociety.isFrenchRegisteredCompany &&
        !this.finalSociety.isValidSiret) ||
      (this.mainSociety &&
        this.mainSociety.hasVatNumber &&
        !this.mainSociety.isFrenchRegisteredCompany &&
        !this.mainSociety.isValidVatNumber) ||
      (this.invoiceSociety &&
        this.invoiceSociety.hasVatNumber &&
        !this.invoiceSociety.isFrenchRegisteredCompany &&
        !this.invoiceSociety.isValidVatNumber) ||
      (this.finalSociety &&
        this.finalSociety.hasVatNumber &&
        !this.finalSociety.isFrenchRegisteredCompany &&
        !this.finalSociety.isValidVatNumber)
    );
  }

  clientChanged() {
    let that = this;
    // that.finalContact = null;
    // that.finalSociety = null;
    // that.finalAddress = null;
    // that.invoiceContact = null;
    // that.invoiceSociety = null;
    // that.invoiceAddress = null;

    if (that.mainIsFinal) {
      that.finalContact = that.mainContact;
      that.finalSociety = that.mainSociety;
      that.finalAddress = that.mainAddress;
      that.finalIsInvoice = false; // Réinitialiser car les valeurs final sont copiées depuis main
    }
    if (that.mainIsInvoice) {
      that.invoiceContact = that.mainContact;
      that.invoiceSociety = that.mainSociety;
      that.invoiceAddress = that.mainAddress;
    }
    if (!that.mainIsInvoice && that.finalIsInvoice) {
      that.invoiceContact = that.finalContact;
      that.invoiceSociety = that.finalSociety;
      that.invoiceAddress = that.finalAddress;
    }
    that.checkAllSiretAndVatNumberValid();
  }

  checkAllSiretAndVatNumberValid() {
    let that = this;
    if (that.mainSociety) {
      that.checkSiret(that.mainSociety.siret, "mainSociety");
      that.checkVatNumber(that.mainSociety.vatNumber, "mainSociety");
    }
    if (that.finalSociety) {
      that.checkSiret(that.finalSociety.siret, "finalSociety");
      that.checkVatNumber(that.finalSociety.vatNumber, "finalSociety");
    }
    if (that.invoiceSociety) {
      that.checkSiret(that.invoiceSociety.siret, "invoiceSociety");
      that.checkVatNumber(that.invoiceSociety.vatNumber, "invoiceSociety");
    }
  }

  next(form) {
    this.submitted = true;
    if (this.demand.id && form.$valid && this.isSiretAndVatNumberValid()) {
      if (this.disabledInput) {
        this.arrow.goto(4, this.s.project, this.s.demand);
      } else {
        this.save(true);
      } //*/
    }
  }

  save(isFull, page) {
    let that = this;
    this.ProductAPI.manageClient({
      id: that.demand.id,
      mainIsFinal: that.mainIsFinal,
      mainIsInvoice: that.mainIsInvoice,
      finalIsInvoice: that.finalIsInvoice,

      contactIdMain: that.mainContact ? that.mainContact.id : null,
      societyIdMain: that.mainSociety ? that.mainSociety.id : null,
      addressIdMain: that.mainAddress ? that.mainAddress.id : null,

      contactIdFinal: that.finalContact ? that.finalContact.id : null,
      societyIdFinal: that.finalSociety ? that.finalSociety.id : null,
      addressIdFinal: that.finalAddress ? that.finalAddress.id : null,

      contactIdInvoice: that.invoiceContact ? that.invoiceContact.id : null,
      societyIdInvoice: that.invoiceSociety ? that.invoiceSociety.id : null,
      addressIdInvoice: that.invoiceAddress ? that.invoiceAddress.id : null,
    })
      .$promise.then((_demand) => {
        let amendedDate = new Date(_demand.dateAmended).getTime();
        if (isFull) {
          page = page >= 0 ? page : 4;
          that.arrow.goto(page, that.s.project, that.s.demand, false, {
            date: amendedDate,
          });
        } else {
          that.Modal.confirm.info(() => {})(
            that.gettextCatalog.getString("Sauvegarde"),
            that.gettextCatalog.getString(
              "Vos données ont bien été sauvegardées"
            ),
            "OK",
            "primary"
          );
        }
        return null;
      })
      //*
      .catch((err) => {
        console.log(err);
        console.log("---->Error on try to save");
        return null;
      }); // @@@ Popup error*/
  }

  loadLocalClient() {
    var that = this;
    that.mainContact = that.mainContact
      ? _.findWhere(that.contacts, {
          id: that.mainContact.id,
        })
      : null;
    that.finalContact = that.finalContact
      ? _.findWhere(that.contacts, {
          id: that.finalContact.id,
        })
      : null;
    that.invoiceContact = that.invoiceContact
      ? _.findWhere(that.contacts, {
          id: that.invoiceContact.id,
        })
      : null;

    that.mainSociety = that.mainSociety
      ? _.findWhere(that.societies, {
          id: that.mainSociety.id,
        })
      : null;
    that.finalSociety = that.finalSociety
      ? _.findWhere(that.societies, {
          id: that.finalSociety.id,
        })
      : null;
    that.invoiceSociety = that.invoiceSociety
      ? _.findWhere(that.societies, {
          id: that.invoiceSociety.id,
        })
      : null;

    that.mainAddress =
      that.mainAddress && that.mainSociety && that.mainSociety.address
        ? _.findWhere(that.mainSociety.address, {
            id: that.mainAddress.id,
          })
        : null;
    that.finalAddress =
      that.finalAddress && that.finalSociety && that.finalSociety.address
        ? _.findWhere(that.finalSociety.address, {
            id: that.finalAddress.id,
          })
        : null;
    that.invoiceAddress =
      that.invoiceAddress && that.invoiceSociety && that.invoiceSociety.address
        ? _.findWhere(that.invoiceSociety.address, {
            id: that.invoiceAddress.id,
          })
        : null;

    if (that.mainIsFinal) {
      that.finalContact = that.mainContact;
      that.finalSociety = that.mainSociety;
      that.finalAddress = that.mainAddress;
      that.finalIsInvoice = false; // Réinitialiser car les valeurs final sont copiées depuis main
    }
    if (that.mainIsInvoice) {
      that.invoiceContact = that.mainContact;
      that.invoiceSociety = that.mainSociety;
      that.invoiceAddress = that.mainAddress;
    }
    if (!that.mainIsInvoice && that.finalIsInvoice) {
      that.invoiceContact = that.finalContact;
      that.invoiceSociety = that.finalSociety;
      that.invoiceAddress = that.finalAddress;
    }
    that.checkAllSiretAndVatNumberValid();
  }
}

export default angular
  .module("dalApp.permission.identification", [])
  .component("identification", {
    template: require("./identification.html"),
    controller: IdentificationController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/identification/identification.component.js